import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    SelectInput,
} from "react-admin";
import ValidateButton from "./ValidateButton";
import RejectButton from "./RejectButton";
import StatusField from "../../components/StatusField";
import ResourceStatusHeader from "../../components/ResourceStatusHeader";
import { useResourceSearchFilter } from "../../hooks/useResourceSearch";

const OobjectFilters = [
    <SelectInput
        source="status"
        label="Statut"
        alwaysOn
        choices={[
            { id: "PENDING", name: "PENDING" },
            { id: "VALIDATED", name: "VALIDATED" },
            { id: "REJECTED", name: "REJECTED" },
        ]}
    />,
];

export default function OobjectList() {
    const searchFilter = useResourceSearchFilter("oobjects");

    return (
        <>
            <ResourceStatusHeader resource="oobjects" title="Oobjects" subtitle="Totaux par statut" />
            <List
                exporter={false}
                perPage={25}
                sort={{ field: "createdAt", order: "DESC" }}
                filters={OobjectFilters}
                filter={searchFilter}
                title="Oobjects"
            >
                <Datagrid rowClick="show" bulkActionButtons={false}>
                    {/* Identifiants (selon ton DTO, adapte si besoin) */}
                    <TextField source="id" />
                    <TextField source="oobjectId" />

                    <TextField source="oobject" label="Oobject" />
                    <TextField source="shortOobject" label="Short" />
                    <TextField source="username" label="Auteur" />

                    <StatusField source="status" />
                    <DateField source="createdAt" showTime />

                    <ValidateButton />
                    <RejectButton />
                </Datagrid>
            </List>
        </>
    );
}
